import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Logger } from "@base-provider";
import SFFieldMapping from "../../components/fieldMapping";
import { COLUMN_MAPPING_STATUS_ACTION } from "../../constants/columnMappingStatus";
//core imports
import { SFGridContainer, SFGridItem } from "../../../components/grid";
import SFDialog from "../../../components/dialog";

const MatchDataStep = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [matchDataState, setMatchDataState] = useState({
    showWarning: false,
    dialog: { open: false, message: "", header: "" },
  });
  useImperativeHandle(ref, () => ({
    onStepChange: stepChangeHandler,
    onLoad: loadStepHandler,
  }));

  const reduxState = useSelector((state) => state.fileUpload);

  const loadStepHandler = (stepperData) => {
    Logger.of("App.uploadFile.matchDataStep.loadStepHandler").info({
      data: stepperData,
    });
  };

  const stepChangeHandler = async (data) => {
    Logger.of("App.uploadFile.matchDataStep.changeStepHandler").info({ data });
    if (data.nextStep < data.activeStep) {
      return true;
    }
    if (
      reduxState.columnMappings.filter(
        (x) =>
          x.action === COLUMN_MAPPING_STATUS_ACTION.CONFIRMED ||
          x.action === COLUMN_MAPPING_STATUS_ACTION.IGNORED
      ).length === reduxState.columnMappings.length
    ) {
      return {
        expectedFields: reduxState.expectedFields,
        mappedData: reduxState.columnMappings,
      };
    } else if (
      reduxState.columnMappings.filter((x) => x.required && !x.src).length !== 0
    ) {
      setMatchDataState((curState) => ({
        ...curState,
        showWarning: true,
        dialog: {
          open: true,
          message: t(
            "fileUploadWizard.fileMapping.dialog.requiredSelectionsLabel"
          ),
          header: t(
            "fileUploadWizard.fileMapping.dialog.requiredSelectionHeader"
          ),
        },
      }));
    } else {
      setMatchDataState((curState) => ({
        ...curState,
        dialog: {
          open: true,
          message: t(
            "fileUploadWizard.fileMapping.dialog.confirmSelectionsLabel"
          ),
          header: t(
            "fileUploadWizard.fileMapping.dialog.confirmSelectionHeader"
          ),
        },
      }));
    }
  };

  const dialogCloseHandler = () => {
    setMatchDataState((curState) => ({
      ...curState,
      dialog: { ...curState.dialog, open: false },
    }));
  };

  return (
    <>
      <SFDialog
        variant="error"
        title={matchDataState.dialog.header}
        message={matchDataState.dialog.message}
        open={matchDataState.dialog.open}
        onClose={dialogCloseHandler}
        primaryButton
        primaryButtonProps={{
          onClick: dialogCloseHandler,
        }}
      />
      <SFGridContainer>
        <SFGridItem xs={12}>
          <SFFieldMapping showWarning={matchDataState.showWarning} />
        </SFGridItem>
      </SFGridContainer>
    </>
  );
});

export default MatchDataStep;
